import { useNavigate } from "react-router-dom";

export default function PageNotFound() {
    const navigate = useNavigate();

    return (
        <div className="d-flex flex-column align-items-center justify-content-center text-center min-vh-100 bg-light px-3">
            <h1 className="display-1 fw-bold text-primary mb-2">404</h1>
            <h2 className="fw-semibold text-dark mb-2">Page Not Found</h2>
            <p className="text-muted mb-4">
                The page you’re looking for doesn’t exist or has been moved.
            </p>
            <button
                type="button"
                className="btn btn-primary px-4"
                onClick={() => navigate("/dashboard")}
            >
                Go to Dashboard
            </button>
        </div>
    );
}
